import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import DeliveryLayout from './layouts/DeliveryLayout';
import ReportsPage from './reports/ReportsPage';
import RoutesNewPage from './routesNew/RoutesNewPage';
import ParcelsPage from './parcels/ParcelsPage';
import AccountsPage from './accounts/AccountsPage';
import { ACCOUNTS_PAGE_MODE } from './accounts/hooks/useAccountDeliveryDriverQuery';
import DailyTaskMonitoringPage from '../wms/delivery/dailyTaskMonitoring/DailyTaskMonitoringPage';
import ParcelSlaMonitoringPage from '../wms/delivery/parcelSlaMonitoring/ParcelSlaMonitoringPage';
import DispatchDeliverySummaryPage from '../wms/delivery/dispatchDeliverySummary/DispatchDeliverySummaryPage';
import DeliveryCompletedSummaryPage from '../wms/delivery/deliveryCompletedSummary/DeliveryCompletedSummaryPage';
import DeliveryTaskPage from './tasks/DeliveryTaskPage';
import SplitOrderPage from './splitOrder/SplitOrderPage';
import RoutesHistoryPage from './routesHistory/RoutesHistoryPage';
import DeliveryDownloadPage from './download/DeliveryDownloadPage';
import DeliveryDspBillListPage from './dsp-bill/DeliveryDspBillListPage';
import DeliveryDspBillDetailPage from './dsp-bill/DeliveryDspBillDetailPage';
import IssueParcelWorkbenchPage from './issueParcelWorkbench/IssueParcelWorkbenchPage';
import DeliveryDspFinanceInfoPage from './finance/DeliveryDspFinanceInfoPage';
import PodExemptListPage from './podExempt/PodExemptListPage';
import PenaltyCenterPage from '../partner-control/penaltyCenter/PenaltyCenterPage';
import PenaltyDetailPage from '../partner-control/penaltyCenter/PenaltyDetailPage';

const DeliveryRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><DeliveryLayout /></AuthGuard>}>
                <Route path="reports" element={<ReportsPage />} />
                <Route path="split-order" element={<SplitOrderPage mode="dsp" />} />
                <Route path="routes-history" element={<RoutesHistoryPage mode="dsp" />} />
                <Route path="routes-new" element={<RoutesNewPage />} />
                <Route path="tasks" element={<DeliveryTaskPage mode="dsp" />} />
                <Route path="parcels" element={<ParcelsPage />} />
                <Route path="accounts" element={<AccountsPage mode={ACCOUNTS_PAGE_MODE.DSP} />} />
                <Route path="daily-task-monitoring" element={<DailyTaskMonitoringPage mode="dsp" />} />
                <Route path="parcel-sla-monitoring" element={<ParcelSlaMonitoringPage mode="dsp" />} />
                <Route path="delivery-completed-summary" element={<DeliveryCompletedSummaryPage />} />
                <Route path="dispatch-delivery-summary" element={<DispatchDeliverySummaryPage />} />
                <Route path="download" element={<DeliveryDownloadPage />} />
                <Route path="dsp-bill" element={<DeliveryDspBillListPage />} />
                <Route path="dsp-bill-detail/:billId" element={<DeliveryDspBillDetailPage />} />
                <Route path="issue-parcel-workbench" element={<IssueParcelWorkbenchPage />} />
                <Route path="finance-info" element={<DeliveryDspFinanceInfoPage />} />
                <Route path="pod-exempt" element={<PodExemptListPage />} />
                <Route path="penalty-center" element={<PenaltyCenterPage />} />
                <Route path="penalty-center/:id" element={<PenaltyDetailPage />} />
            </Route>
        </Routes>
    );
};

export default DeliveryRoutes; 